import React, { Component } from 'react'
import { Grid, Card, Dimmer, Loader, Statistic } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { getApiData } from 'helpers/api'
import { DATASOURCE } from 'Constants'
import { translate } from 'react-i18next'
import qs from 'query-string'
import CardWrapper from 'screens/common/CardWrapper'
import Summary from './Summary'
import BarChart from 'components/BarChart'
import DonutChart from 'components/DonutChart'
import LineChart from 'components/LineChart'


class CallSummary extends Component {

  componentDidMount() {
    getApiData(DATASOURCE.SUMMARY,this.props.location.search);
    getApiData(DATASOURCE.ACTIVE_CALLS,this.props.location.search);
    getApiData(DATASOURCE.LICENSE_OVERAGE,this.props.location.search);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      getApiData(DATASOURCE.SUMMARY,this.props.location.search);
      getApiData(DATASOURCE.ACTIVE_CALLS,this.props.location.search);
      getApiData(DATASOURCE.LICENSE_OVERAGE,this.props.location.search);
    }
  }

  getLicenseLink(arg) {
    let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
    let params = {};
    if (this.props.location.search) {
      params = qs.parse(this.props.location.search);
    }
    params["exceedLicenseCapacity"] = arg;
    myUrl = myUrl.replace("summary","");
    return myUrl + "list?" + qs.stringify(params);
  }

  render() {
    const { t } = this.props;
    return (
      <Grid centered padded stackable>

        <Grid.Column width={16}>
          <Summary {...this.props} />
        </Grid.Column>

        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.CallEndTitle")}
            isLoading={this.props.summary.loading}
          >
            <DonutChart
              decimals={0}
              series={this.props.summary.endReasonSeries}
              drilldown={this.props.summary.endReasonDrilldown}
            />
          </CardWrapper>
        </Grid.Column>

        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.TopEndpointsCount")}
            isLoading={this.props.summary.loading}
          >
            <BarChart
              decimals={0}
              type="bar"
              yAxisText={t("Screens.Calls.Summary.TopEndpointsCountYAxis")}
              series={this.props.summary.fromCount}
              xAxisCategories={this.props.summary.fromCountCategories}
              colorByPoint={true}
            />
          </CardWrapper>
        </Grid.Column>

        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.TopConferences")}
            isLoading={this.props.summary.loading}
          >
            <BarChart
              decimals={0}
              type="bar"
              yAxisText={t("Screens.Calls.Summary.TopConferencesYAxis")}
              series={this.props.summary.topConferencesSeries}
              xAxisCategories={this.props.summary.topConferencesCategories}
              colorByPoint={true}
            />
          </CardWrapper>
        </Grid.Column>

        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.CallDuration")}
            isLoading={this.props.summary.loading}
          >
            <BarChart
              decimals={0}
              type="bar"
              yAxisText={t("Screens.Calls.Summary.CallDurationYAxis")}
              series={this.props.summary.durationSeries}
              xAxisCategories={this.props.summary.durationCategories}
              stackBars="normal"
            />
          </CardWrapper>
        </Grid.Column>
        <Grid.Column width={8}>
          <Card centered as={Link} to={this.getLicenseLink("all")}>
            <Card.Content>
              <div style={{textAlign: "center"}}>
                <Statistic
                  label={t("Screens.Calls.Summary.LicenseOverage")}
                  value={this.props.licenseOverage.accepted + this.props.licenseOverage.rejected}
                  size="small"
                />
              </div>
              <Dimmer active={this.props.summary.loading} inverted>
                <Loader />
              </Dimmer>
            </Card.Content>
          </Card>
          <Card centered as={Link} to={this.getLicenseLink("rejected")}>
            <Card.Content>
              <div style={{textAlign: "center"}}>
                <Statistic
                  label={t("Screens.Calls.Summary.LicenseRejected")}
                  value={this.props.licenseOverage.rejected}
                  size="small"
                />
              </div>
              <Dimmer active={this.props.summary.loading} inverted>
                <Loader />
              </Dimmer>
            </Card.Content>
          </Card>
          <Card centered as={Link} to={this.getLicenseLink("allowed")}>
            <Card.Content>
              <div style={{textAlign: "center"}}>
                <Statistic
                  label={t("Screens.Calls.Summary.LicenseSurges")}
                  value={this.props.licenseOverage.accepted}
                  size="small"
                />
              </div>
              <Dimmer active={this.props.summary.loading} inverted>
                <Loader />
              </Dimmer>
            </Card.Content>
          </Card>
        </Grid.Column>

        <Grid.Column width={8}>
          {this.props.activeCalls.series && this.props.activeCalls.series.length > 0 ?
            (
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.ActiveCalls")}
            isLoading={this.props.activeCalls.loading}
          >
            <BarChart
              decimals={0}
              type="bar"
              yAxisText={t("Screens.Calls.Summary.ActiveCallsYAxis")}
              series={this.props.activeCalls.series}
              xAxisCategories={this.props.activeCalls.categories}
              showLegend={true}
              stackBars="normal"
            />
          </CardWrapper>
            ) : (
          <Card centered>
            <Card.Content>
              <div style={{textAlign: "center"}}>
                <Statistic
                  label={t("Screens.Calls.Summary.ActiveCalls")}
                  value='0'
                  size="small"
                />
              </div>
              <Dimmer active={this.props.summary.loading} inverted>
                <Loader />
              </Dimmer>
            </Card.Content>
          </Card>
            )
          }
        </Grid.Column>
        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.ActiveCallsPer") + this.props.summary.timeInterval}
            isLoading={this.props.summary.loading}
          >
            <LineChart
              decimals={0}
              yAxisText={t("Screens.Calls.Summary.ActiveCallsPerYAxis")}
              xAxisType="datetime"
              series={this.props.summary.activeCallsPerHourSeries}
            />
          </CardWrapper>
        </Grid.Column>

        
        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.Devices")}
            isLoading={this.props.summary.loading}
          >
            <DonutChart
              decimals={0}
              series={this.props.summary.agentSeries}
              drilldown={this.props.summary.agentDrilldown}
            />
          </CardWrapper>
        </Grid.Column>
        <Grid.Column width={8}>
          <CardWrapper {...this.props} 
            title={t("Screens.Calls.Summary.Devices")}
            isLoading={this.props.summary.loading}
          >
            <BarChart
              decimals={0}
              type="bar"
              yAxisText={t("Screens.Calls.Summary.DevicesYAxis")}
              series={this.props.summary.agentSeries}
              drilldown={this.props.summary.agentDrilldown}
              colorByPoint={true}
            />
          </CardWrapper>
        </Grid.Column>
      </Grid>
    );
  }
}

// REDUX STATE
const mapToProps = state => {
  return {
    summary: state.summary,
    activeCalls: state.activeCalls,
    licenseOverage: state.licenseOverage
  }
};
        
export default translate()(
  connect(
    mapToProps,
    null
  )(CallSummary)
);

